import type { Guard } from './index';
import { useAuthStore } from '@/store/auth.store';

const unauthentication: Guard = (to, from, next) => {
  const authStore = useAuthStore();
  if (authStore.getMemberId() && authStore.getSiteId()) {
    return next('/home');
  }
  return next();
};

export default unauthentication;
